<!-- <li class="panel"> -->
<div class="tipo_adempimento doc_scadenza">
	<div class="col-xs-12 col-sm-6">
		<ng-template [ngIf]="scadenza.tipoScadenza.id != '3' && scadenza.tipoScadenza.id != 'ATTIVITA'">
		<p>
		<button (click)="emitEntity(scadenza)"
			class="btn btn-primary associa" type="submit">Allega</button>
			{{ scadenza.tipoScadenza?.label }}<span
				class="glyphicon glyphicon-exclamation-sign"
				[ngClass]="{'red':scadenza.priorita?.label == 'ALTA', 'yellow':scadenza.priorita?.label == 'MEDIA', 'green': scadenza.priorita?.label == 'BASSA' }"></span>
				<span class="{{ scadenza.priorita?.label | lowercase }}">{{scadenza.priorita?.label }}</span>
		</p>
		</ng-template>
		<ng-template [ngIf]="scadenza.tipoScadenza.id === 'ATTIVITA'">
		<p>
		<button (click)="emitEntity(scadenza)"
			class="btn btn-primary associa" type="submit">Allega</button>
			Attivit&agrave; <span class="glyphicon glyphicon-exclamation-sign"
				[ngClass]="{'red':scadenza.priorita?.label == 'ALTA', 'yellow':scadenza.priorita?.label == 'MEDIA', 'green': scadenza.priorita?.label == 'BASSA' }"></span>
				<span class="{{ scadenza.priorita?.label | lowercase }}">{{scadenza.priorita?.label }}</span>
		</p>
		</ng-template>
	</div>
	<div class="col-xs-12 col-sm-6">
		<div class="data_opzioni scadenze" style="position: relative!important; top:0!important">
			<ul style="margin-top: 3px;">
				<ng-template [ngIf]="!scadenza.evasa && scadenza.giorniRitardo">
				<!--<li class="delay"><span class="ritardo">{{scadenza.giorniRitardo}}
						gg</span> di ritardo</li>-->
				<li class="stato_scadenze inevasa">inevasa</li>
				</ng-template>
				<ng-template [ngIf]="!scadenza.evasa && !scadenza.giorniRitardo">
				<li class="stato_scadenze da_evadere">da evadere</li>
				</ng-template>
				<ng-template [ngIf]="scadenza.evasa">
				<li class="stato_scadenze evasa">evasa</li>
				</ng-template>
				<li>{{ scadenza.dataScadenza | dateformatter:'DD/MM/YYYY HH:mm' }}</li>
				<li>{{ scadenza.ora }}</li>
			</ul>
		</div>
	</div>
</div>
<div *ngIf="scadenza.descrizione" class="documento white">
	<p>{{ scadenza.descrizione }}</p>
</div>
<div class="collapse rinvio" id="#rinviotab1{{scadenza.id}}"
	[ngClass]="{'in': scadenza.isOpen}">
	<h4 [hidden]="true">Rinvio dal</h4>
	<p [hidden]="true" class="data">{{ scadenza.dataScadenza |
		date:'d/M/y' }}</p>
	<form>
		<div class="row">
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Tipo scadenza'"
				[valueInput]="scadenza.tipoScadenza?.label"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Motivo scadenza'"
				[valueInput]="scadenza.motivo?.label"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Priorit&agrave;'"
				[valueInput]="scadenza.priorita?.label"></div>
		</div>
		<div class="row">
			<div labelTextInput class="col-sm-4 bloccodati"
				[typeLabel]="'dateTime'" [labelInput]="'Data'"
				[valueInput]="scadenza.dataScadenza"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
				[labelInput]="'Data promemoria'"
				[valueInput]="scadenza.dataPromemoria"></div>
			<div labelTextInput class="col-sm-4 bloccodati"
				[typeLabel]="'boolean'" [labelInput]="'Pubblica'"
				[valueInput]="scadenza.pubblica"></div>
		</div>
		<div class="row">
			<div labelTextInput class="col-sm-4 bloccodati"
				[typeLabel]="'boolean'" [labelInput]="'Evaso'"
				[valueInput]="scadenza.evasa"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
				[labelInput]="'Data evasione'" [valueInput]="scadenza.dataEvasione"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Appunto'" [valueInput]="scadenza.appunto"></div>
		</div>
			<div class="row">
				<div class="col-sm-12 bloccodati">
					<p>
						<label class="col-sm-12">Note</label>
						<span class="longtext">{{ scadenza.note }}</span>
					</p>
				</div>
			</div>
	</form>
</div>
<!-- </li> -->
